export default __webpack_public_path__ + "static/media/sample-R2-svgHeroBluev1.5c06ace3.svg";